import React, { useState } from "react";
import "../../styles/components/FaqHero.css";

import faqBg from "../../img/hero/faq-hero.webp";
import btnArrow from "../../img/hero/arrow-herro.png";

import Modal from "../../components/Modal";
import ContactFormSimple from "../../components/ContactFormSimple";

export default function ContactsFaqHero() {
  const [openModal, setOpenModal] = useState(false);

  return (
    <section className="contacts-faq contacts-faq-anim" aria-label="Contacts FAQ hero">
      {/* Правий образ */}
      <img
        className="contacts-faq__bg contacts-faq-anim__art"
        src={faqBg}
        alt=""
        aria-hidden="true"
      />

      {/* Скляна плашка з заголовком */}
      <div className="contacts-faq__title contacts-faq-anim__title">
        <h1 className="contacts-faq__h1">
          Frequently Asked <strong>Questions</strong>
        </h1>
      </div>

      {/* Низ: опис + глобальна кнопка */}
      <div className="contacts-faq__bottom contacts-faq-anim__bottom">
        <p className="contacts-faq__lead">
          Get in touch to discuss your next breakthrough idea or existing project.
        </p>

        <button
          type="button"
          className="Secondary v2"
          onClick={() => setOpenModal(true)}
        >
          <span className="Secondary__text">Start Your Project</span>
          {btnArrow
            ? <img className="Secondary__circle" src={btnArrow} alt="" aria-hidden="true" />
            : <span className="Secondary__circle">➜</span>}
        </button>
      </div>

      {/* Модалка з формою */}
      <Modal open={openModal} onClose={() => setOpenModal(false)} title="Start your project">
        <ContactFormSimple onSubmit={() => setOpenModal(false)} />
      </Modal>
    </section>
  );
}
